import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { User } from '@app/users/user.interface';
import { UsersDataService } from '@app/users/users-data.service';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {
  LIST_SIZE = 30;
  searchUserName = '';
  usersTypeChanged = [
    {value: 'admin'},
    {value: 'operator'}
  ];
  userServicesChanged;
  userRoleChanged;
  userType;
  userService;
  sortByCall;
  allRolesList;
  selectedRoleId;
  @Output() onDbClick = new EventEmitter();
  select = [];
  selectService = [];
  dataLength: number;

  @Input() userList: Array<User>;

  @Output() currentUser: EventEmitter<User> = new EventEmitter();

  selectedUser: User;
  displayedColumns: string[] = ['name', 'created_at', 'type', 'roles', 'services'];
  constructor(public dataService: UsersDataService) { }

  ngOnInit() {
    this.dataService.loadUserFormdData();
    this.dataService.getUsersByScrooll(this.LIST_SIZE, this.userService, this.selectedRoleId, this.userType, this.sortByCall);
    this.dataService.taskCount.subscribe(length => {
      this.dataLength = length;
    });
    this.dataService.getAllRoles().subscribe(roles => {
      this.userRoleChanged = roles.data;
      this.allRolesList = roles.data;
      this.select = roles.data.map(role => role.id);
    });
    this.dataService.getAllServices().subscribe(services => {
      this.userServicesChanged = services['data'];
      this.selectService = services['data'].filter(service => {
        if (service.id === 838) {
          return service;
        }
      });
      this.selectService = this.selectService.map(el => el.id);
    });
  }

  toList(arr, key) {
    return arr.map(el => el[key]).join(', ');
  }

  scrollPage(diff) {
    this.dataService.getUsersByScrooll(diff += 30, this.userService, this.selectedRoleId, this.userType, this.sortByCall);
    this.LIST_SIZE = diff;
  }

  onDoubleClick (user) {
    this.onDbClick.emit(user);
  }

  selectUser(user) {
    this.selectedUser = user;
    this.currentUser.emit(user);
  }
  searchUser() {
    this.dataService.getSearchUsersForName(this.searchUserName);
  }
  sortData(event) {
    this.sortByCall = event;
    this.dataService.getUsersByScrooll(this.LIST_SIZE, this.userService, this.selectedRoleId, this.userType, this.sortByCall);
  }
  filteringOfType(event) {
    this.userType = event;
    this.dataService.getUsersByScrooll(this.LIST_SIZE, this.userService, this.selectedRoleId, this.userType, this.sortByCall);
  }
  filteringOfService(event) {
    this.userService = event;
    this.dataService.getUsersByScrooll(this.LIST_SIZE, this.userService, this.selectedRoleId, this.userType, this.sortByCall);
  }
  filteringOfRole(event) {
    this.selectedRoleId  = event;
    this.dataService.getUsersByScrooll(this.LIST_SIZE, this.userService, this.selectedRoleId, this.userType, this.sortByCall);
  }

}



// WEBPACK FOOTER //
// ./src/app/users/users-list/users-list.component.ts